<template>
    <b-container class="text-center">

        <br><br>
        <div v-if="orderToken == '' || orderToken == undefined">
            C'è stato un problema, token non trovato!
        </div>
        
        <div v-else>

            <span v-if="loading && this.$router.currentRoute.query.status =='SUCCESS'">
              Attendi, stiamo effettuando la prenotazione richiesta...
            </span>

            <span v-else>
              Siamo spiacenti, si è verificato un problema.
              Contatta l'assistenza indicando il seguente numero ordine Scalapay: <b>{{orderToken}}</b>
            </span>

            <br><br>
            <Spinner v-if="loading" />
        </div>
        <br><br>
    </b-container>
</template>

<script>
//import Router from 'vue-router'
import Spinner from '../../atoms/spinner'
import Api from '../../../api'
import Store from "@/vuex/store";

export default {
    name: 'scalapay-confirm',
    components:
    {
        Spinner,
    },
    props:
    {
    },
    data()
    {
        return {
            orderToken: '',
            status: '',
            loading: true,
            errors: true,
        }
    },
    mounted()
    {
        let _this = this

        _this.orderToken = _this.$router.currentRoute.query.orderToken
        _this.status = _this.$router.currentRoute.query.status

        if(_this.orderToken !== undefined)
        {
            _this.scalapayConfirm()
        }
        else
        {
            _this.loading = false
        }
    },
    methods:
    {
        scalapayConfirm()
        {
            let _this = this

            Api.scalapayConfirm({
              token: Store.state.token,
              orderToken: _this.orderToken,
              status: _this.status,
            })
            .then((results) => {


                if(results && results.itinerary_id){

                  _this.errors = false

                  if(_this.$gtm){

                    _this.$gtm.trackEvent({
                      event: 'customEvent',
                      category: 'userBehaviour',
                      action: 'confirmedCheckout',
                      label: results.email,
                      value: results.price,
                    });

                    _this.$gtm.trackEvent({
                      event: 'customEvent',
                      category: 'partnerBehaviour',
                      action: 'confirmedCheckout',
                      label: 'scalapay',
                      value: results.price,
                    });


                    let eventGeoExtraValue = (_this.geo.matchLevel == 'inSalabam')
                        ? _this.geo.inSalabamId
                        : (_this.geo.matchLevel == 'property')
                            ? _this.geo.propertyId
                            : 0;

                    _this.$gtm.trackEvent({
                      event: 'customEvent',
                      category: 'confirmedCheckoutSearch',
                      action: _this.geo.matchLevel,
                      label: _this.geo.label,
                      value: eventGeoExtraValue,
                    });

                  }

                  if(window.LogRocket) window.LogRocket.track('confirmedCheckout')
                  if(window.clarity){
                    window.clarity("set", "checkout", "confirmed")
                    window.clarity("set", "scalapay", "confirmedCheckout")
                  }

                  if(results.updateAvailabilityTo) _this.mixinSendMutation('setAvailability',results.updateAvailabilityTo)

                  _this.mixinGoTo('confirm',{
                    confirmcode: results.confirmcode,
                    itinerary_id: results.itinerary_id,
                    msg: results.msg,
                    newAffiliateReferenceId: results.newAffiliateReferenceId,
                  })

                }


                _this.loading = false


            })
        }
    },
    computed: {
      geo: {
        get() { return this.$store.state.geo },
        set() {}
      },
    },
}
</script>